export const DISPLAY_SIZES = ['sm', 'md', 'lg'];

// Relative multipliers composed into each module's existing font-size via calc(),
// never absolute pixel values, so sizing stays proportional across TV/tablet/phone.
export const SIZE_MULTIPLIERS = { sm: 0.75, md: 1, lg: 1.3 };

// Every module a host can size; `hideable: false` means it can never be turned off (timer).
export const DISPLAY_MODULES = [
  { key: 'level',     label: 'Level Number',        hideable: true },
  { key: 'timer',     label: 'Countdown Timer',      hideable: false },
  { key: 'blinds',    label: 'Blinds / Ante',        hideable: true },
  { key: 'payouts',   label: 'Payouts',               hideable: true },
  { key: 'prizePool', label: 'Total Prize Pool',      hideable: true },
  { key: 'avgStack',  label: 'Average Chip Stack',    hideable: true },
  { key: 'nextLevel', label: 'Next Level Preview',    hideable: true },
];

// Named hex values shared with ChipColorPicker.vue's preset list, so the two
// curated palettes don't hardcode the same colors in two places and drift apart.
export const SHARED_PALETTE = {
  blue: '#1565C0',
  green: '#2E7D32',
  purple: '#6A1B9A',
};

// Curated palette only — free-form color pickers aren't offered here so every
// display stays legible against the dark timer background (see spec non-goals).
export const ACCENT_COLORS = [
  { name: 'Default', value: null },
  { name: 'Blue',    value: SHARED_PALETTE.blue },
  { name: 'Green',   value: SHARED_PALETTE.green },
  { name: 'Red',     value: '#C62828' },
  { name: 'Purple',  value: SHARED_PALETTE.purple },
  { name: 'Orange',  value: '#E65100' },
  { name: 'Teal',    value: '#00695C' },
];

export function defaultDisplayConfig() {
  return {
    displayName: '',
    accentColor: null,
    showLastRebuyNotice: true,
    modules: DISPLAY_MODULES.reduce((acc, { key, hideable }) => {
      acc[key] = hideable ? { show: true, size: 'md' } : { size: 'md' };
      return acc;
    }, {}),
  };
}

// Fills in any missing/invalid fields with defaults so structures saved before
// this feature existed (or before a new module key was added) render exactly
// like they always have.
export function mergeDisplayConfig(partial) {
  const defaults = defaultDisplayConfig();
  if (!partial || typeof partial !== 'object') return defaults;

  const modules = {};
  for (const { key, hideable } of DISPLAY_MODULES) {
    const src = partial.modules?.[key];
    const size = src && DISPLAY_SIZES.includes(src.size) ? src.size : 'md';
    modules[key] = hideable
      ? { show: src && typeof src.show === 'boolean' ? src.show : true, size }
      : { size };
  }

  return {
    displayName: typeof partial.displayName === 'string' ? partial.displayName : defaults.displayName,
    accentColor: partial.accentColor ?? defaults.accentColor,
    showLastRebuyNotice: typeof partial.showLastRebuyNotice === 'boolean' ? partial.showLastRebuyNotice : defaults.showLastRebuyNotice,
    modules,
  };
}
